import { Injectable } from '@angular/core';

/**
 * B3: never two Backs that lead to the same place.
 *
 * The bottom nav's Back tab is a history back (Location.back()). A page that
 * renders its OWN history back therefore duplicates it exactly, and both were
 * visible at once (the widget-settings header arrow and the full-results
 * symptoms back both sat above the nav's Back tab).
 *
 * Instead of listing routes in the nav - which silently rots the next time a
 * screen grows its own back - the PAGE declares it: register() on init,
 * release() on destroy, and the nav steps aside while any page-level back is
 * on screen. A counter, not a boolean, so an overlapping route transition
 * (new page registers before the old one is destroyed) cannot leave it stuck.
 */
@Injectable({ providedIn: 'root' })
export class PageBackService {
  private count = 0;

  /** True while a page is rendering its own history-back control. */
  get hasPageBack(): boolean {
    return this.count > 0;
  }

  register(): void {
    this.count++;
  }

  release(): void {
    this.count = Math.max(0, this.count - 1);
  }
}
